import { clearPendingDomains, clearPermissioningCache, resetAllApiCaches, selectAllProducts, setSelectedAccount, setSelectedAccountId, useAppDispatch, useAppSelector, } from '@ibk/shared-config';
import { ApiProductStatus, ProductAlias } from '@ibk/shared-types';
import { saveLastAccessedCompany } from '@ibk/shared-utils';
import { getAllAccounts, getAllAccountsInfo, updateAccountId } from '../../utils/personAccessStorage';
export function useAccount() {
    const dispatch = useAppDispatch();
    const products = useAppSelector(selectAllProducts);
    function getAccounts() {
        return getAllAccounts();
    }
    function hasMultipleAccounts() {
        return getAllAccountsInfo()?.count > 1;
    }
    function updateSelectedAccount(account) {
        dispatch(setSelectedAccountId(account.id));
        dispatch(setSelectedAccount(account));
        dispatch(clearPermissioningCache());
        dispatch(clearPendingDomains());
        resetAllApiCaches(dispatch);
        saveLastAccessedCompany(account.id);
        updateAccountId(account);
    }
    function isLoadingPJAccount() {
        const contaDigital = products[ProductAlias.CONTA_DIGITAL];
        return contaDigital.isLoading;
    }
    function hasActivePJAccount() {
        const contaDigital = products[ProductAlias.CONTA_DIGITAL];
        const contaDigitalData = contaDigital.data;
        return contaDigitalData?.status === ApiProductStatus.ACTIVE;
    }
    function hasAvailablePJAccount() {
        const contaDigital = products[ProductAlias.CONTA_DIGITAL];
        const contaDigitalData = contaDigital.data;
        return contaDigitalData?.status === ApiProductStatus.AVAILABLE;
    }
    function getPJAccountStatus() {
        const contaDigital = products[ProductAlias.CONTA_DIGITAL];
        return contaDigital.data?.status;
    }
    function shouldShowPromo() {
        const contaDigital = products[ProductAlias.CONTA_DIGITAL];
        const contaDigitalData = contaDigital.data;
        return (contaDigitalData?.status === ApiProductStatus.AVAILABLE ||
            contaDigitalData?.status === ApiProductStatus.ACTIVATING ||
            contaDigitalData?.status === ApiProductStatus.DEACTIVATED);
    }
    function hasActivatingPJAccount() {
        const contaDigital = products[ProductAlias.CONTA_DIGITAL];
        const contaDigitalData = contaDigital.data;
        return contaDigitalData?.status === ApiProductStatus.ACTIVATING;
    }
    function hasNotApprovedPJAccount() {
        const contaDigital = products?.[ProductAlias.CONTA_DIGITAL];
        const contaDigitalData = contaDigital?.data;
        return contaDigitalData?.status === ApiProductStatus.NOT_APPROVED;
    }
    return {
        getAccounts,
        hasMultipleAccounts,
        isLoadingPJAccount,
        hasActivatingPJAccount,
        hasNotApprovedPJAccount,
        updateSelectedAccount,
        hasActivePJAccount,
        hasAvailablePJAccount,
        shouldShowPromo,
        getPJAccountStatus,
    };
}
